import ProductSearchBasic from "components/Product/ProductSearchBasic"
import React, { Component } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router"
import shop from "../shop/shop"
import { translate } from "translate"
import queryString from "querystring"
import { Button, Col, Row, Table } from "elemental"
import ProductSearch from "../components/Product/ProductSearch"
import ProductList from "../components/Product/ProductList"
import ProductCol5 from "../components/Product/ProductCol5"
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs"
import ButtonLove from "../components/Button/ButtonLove"
import Badge from "../components/Product/Badge"
import Price from "../components/Price/Price"
import ProductQuantityGroup from "../components/Product/ProductQuantityGroup"
import "./ProductPage.scss"
import Slider from "components/Slider/Slider"
import { Image } from "semantic-ui-react";

window.queryString = queryString

let lastProducts = null


const ProductThumbnails = ( { product, query = {}, download = false, fullscreen = false } ) => {
  return <div className="product-images pt1 flex">
    {product.img_srcs.map( ( entry, key ) => {
      const isActive = key === Number( query.image )
      return <div className="img-container " key={key}>
        <Link
          className={`img-thumbnail ${isActive ? "active" : "not-active"}`} key={entry.img_src_small}
          to={{ pathname: `/product/${product.map_id}`, search: `?image=${key}&fullscreen=${fullscreen ? "1": "1"}` }}><img src={entry.img_src_small}
                                                                                                                             alt=""/></Link>
        {(download && shop.session) && <a
          download={`${product.article_nr}-${product.title}-${key}.jpg`} // works on same origin
          href={entry.img_src_large}
          className="db ttu pt2 tc black-60 f7  "><Button>download</Button></a>}
      </div>
    } )}
  </div>
}


export default class ProductPage extends Component {
  constructor( { params } ) {
    super()
    this.state = {
      id               : params.id,
      ean              : params.ean,
      product          : {},
      fullscreenElement: null
    }
  }
  
  loadProduct( id ) {
    shop.product( id )
      .then( product => {
        console.log( "ProductPage::loaded", product )
        product.count = 1
        shop.analytics.push( product.map_id )
        lastProducts = shop.analytics.lastProducts( 5 )
          .filter( ( id ) => id !== product.map_id )
        this.setState( { product: product } )
      } )
  }
  
  loadProductEan( ean ) {
    var eanFilter = new shop.Filter().field( "barcode" )
      .extra( false )
      .value( ean )
    shop.products.search( "%%", { filter: eanFilter } )
      .then( response => response.result[ 0 ] )
      .then( product => new shop.ProductModel( product ) )
      .then( product => {
        console.log( "ProductPage::loaded", product )
        product.count = 1
        shop.analytics.push( product.map_id )
        lastProducts = shop.analytics.lastProducts( 5 )
          .filter( ( id ) => id !== product.map_id )
        this.setState( { product: product } )
      } )
      .catch( err => {
        console.error( `Failed getting product from EAN ${ean}`, err )
      } )
  }
  
  add = ( { product } ) => {
    if ( product.count === 0 ) return shop.cart.remove( product )
    return shop.cart.add( product )
  }
  
  updateProduct = ( { product } ) => {
    this.setState( { product } )
  }
  
  componentWillReceiveProps( { params: { id, ean } } ) {
    if ( id ) {
      if ( id === this._id ) return
      this._id = id
      this.loadProduct( id )
    }
    if ( ean ) {
      if ( ean === this._ean ) return
      this._ean = ean
      this.loadProductEan( ean )
    }
  }
  
  showFullscreen = ( element ) => {
    this.setState( {
      fullscreenElement: element
    } )
  }
  
  componentDidMount() {
    const { id, ean } = this.state
    if ( id ) this.loadProduct( id )
    if ( ean ) this.loadProductEan( ean )
  }
  
  render() {
    let { product } = this.state
    let { fullscreenElement } = this.state
    if ( product && !product._type ) return null // (rough) duck type check for ProductModel
    
    /// let category = _.first( shop.categories.filter( e => product.cats[ 0 ].cat_id === e.map_id ) )
    
    let img_srcs = product.img_srcs
    
    const query = queryString.parse( this.props.location.search.slice( 1 ) )
    console.log( { query } )
    const { image } = query
    const fullscreen = query.fullscreen === "1"
    let currentImage = false
    try {
      currentImage = product.img_srcs[ image ] || product.img_srcs[ 1 ] || product.img_srcs[ 0 ]
    } catch (error) {
      console.warn( "Failed setting smart default image - revert false", { error } )
      currentImage = false
    }
    
    // let categoryName = shop.categoryName(product.cats[0].cat_id)
    let path = shop.getCategoryPath( product.cats && product.cats[ 0 ] && product.cats[ 0 ].cat_id )
    // console.log( `path`, path )
    path.push( {
      title: product.title,
      link : ""
    } )
    const list = shop.orderlist.default
    const hasRabatt = product.pinfos && product.pinfos.zuab !== "0"
    const categoryId = product.cats && product.cats[ 0 ].cat_id
    const category = shop.categoriesById.get( categoryId )
    return (
      <div className="container mb">
        {fullscreen && <Fullscreen
          product={product}
          query={query}
        >
          <div>
            <div className="absolute top-1 left-1 z-5">
              
              <ButtonLove
                className={"dib pr2s"}
                list={list} s
                elementInActive={<Button><i className="icon icon-heart-empty"/> {translate( "orderlist.on_orderlist" )}</Button>}
                elementActive={<Button><i className="icon icon-heart"/> {translate( "orderlist.on_orderlist" )}</Button>}
                product={product}/>
              <Button type={"primary"} onClick={() => this.add( { product } )}>
                <i className="icon icon-cart-plus"/> {translate( "cart.cart" )}
              </Button>
            </div>
            
            {currentImage &&
            <div className="absolute z-0 top-0 left-0 bottom-0 right-0 w-100 h-100">
              <Link to={{ pathname: `/product/${product.map_id}`, search: "?" + queryString.encode( { image, fullscreen: 0 } ) }} style={{ backgroundImage: `url(${currentImage.img_src_large})` }}
                    className="db w-100 vh-100 contain bg-center">
              </Link>
            </div>}
          </div>
        
        </Fullscreen>}
        <Breadcrumbs path={path}/>
        <section className="product product-single ">
          <Row>
            <Col sm="1"
                 md="1/2"
                 lg="7/12"
                 className="relative">
              <div className="absolute right-2 pr3 z-5"><Badge product={product}/></div>
              
              <div className="hide-child">
  
                <Slider
                  centerMode
                  emulateTouch={true}
                  centerSlidePercentage={100}
                  infiniteLoop={true}
                  showThumbs={false}
                  showArrows={true}
                  showIndicators={true}
                  showStatus={false}>
                  {product.img_srcs.map( urls => {
                    return <div key={urls.img_src_medium}>
                      <img
                        style={{
                          maxHeight: 520,
                          margin   : "auto",
                          display  : "block"
                        }}
                        src={urls.img_src_medium}/>
                    </div>
                  })}
                </Slider>
                
                <div className="child fr">
                  <Link className={" "} to={{ pathname: `/product/${product.map_id}`, search: "?" + queryString.encode( { image, fullscreen: 1 } ) }}>
                    <Button>
                      <i className={"icon icon-search"}/>
                    </Button>
                  </Link>
                </div>
              </div>
            
            
            </Col>
            <Col sm="1"
                 md="1/2"
                 lg="5/12">
              <TitleSection hasRabatt={hasRabatt} product={product}/>
              {shop.session && <ActionSection product={product}
                                              onChange={this.updateProduct}
                                              onAdd={this.add}/>
              }
              
              {!shop.session && <div>
                <p>
                  {translate( "shop.please_login_for_product_details" )}
                </p>
                <Link to={`/login?referrer=${document.location.pathname}`}><Button className="mb1"> {translate( "shop.login" )}</Button></Link> <br/>
                <Link to="/customer_registration"> <Button>{translate( "shop.register" )}</Button></Link>
              </div>}
              
              {/*<DescriptionSection product={product}/>*/}
              {shop.session && <Table>
                <tbody>
                
                <tr>
                  <td>
                    <label>
                      VE
                    </label>
                  </td>
                  <td>
                    {product.unit_multi} {translate( "product.piece" )}
                  </td>
                </tr>
                
                <tr>
                  <td>
                    <label>
                      EAN
                    </label>
                  </td>
                  <td>
                    {product.barcode}
                  </td>
                </tr>
                
                {product.extras.material && <tr>
                  <td>
                    <label>
                      <span className="">{translate( "Material" )}</span>
                    </label>
                  </td>
                  <td>
                    {product.extras.material}
                  </td>
                </tr>}
                
                {product.extras.dimensions && <tr>
                  <td>
                    <label>
                      <span className="">{translate( "Größe" )}</span>
                    </label>
                  </td>
                  <td>
                    {product.extras.dimensions}
                  </td>
                </tr>}
                
                </tbody>
              </Table>}
            
            </Col>
          </Row>
          
          <ProductThumbnails product={product} query={query} download/>
        
        </section>
        
        
        <section>
          {product.extras.articletype === "02" && <div>
            <div className="fr f6 ttu"><Link to={"/articletype/02"}>Alle anzeigen</Link></div>
            <ProductSearchBasic
              to={"/articletype/02"}
              title={"Weitere Sale Artikel"}
              query={
                {
                  value : "%%",
                  filter: { "extra": true, "op": "equals", "value": "02", "field": "articletype" },
                  start : 0,
                  count : 5,
                  sort  : "random",
                  lang  : "de"
                }
              }
              repeat={ProductCol5}/>
          </div>}
        
        </section>
        
        {/*Product Slider "Category"*/}
        {category && <section key={`category-${product.map_id}`}>
          <div className="fr f6 ttu"><Link to={`/collection/${categoryId}`}>Alle anzeigen</Link></div>
          <ProductSearch
            to={`/collection/${categoryId}`}
            title={`Weitere ${category.title} Produkte`}
            count={5}
            start={0}
            sort="random"
            cats={[product.cats && product.cats[ 0 ].cat_id]}
            query="%%"
            repeat={ProductCol5}/>
        </section>}
        
        {/*Product Slider "last viewed"*/}
        <section key={`last-${product.map_id}`}>
          <ProductList
            title={translate( "category.last_viewed" )}
            count={5}
            start={0}
            list={lastProducts}
            repeat={ProductCol5}/>
        </section>
      </div>
    )
  }
}

ProductPage.propTypes = {
  price: PropTypes.any
}

class Fullscreen extends Component {
  
  componentWillUnmount() {
    console.log( "unmount Fullscreen" )
    document.body.classList.remove( "no-scroll" )
  }
  
  render() {
    const { product, children, query } = this.props
    document.body.classList.remove( "no-scroll" )
    if ( !children ) {
      return null
    }
    window.scrollTo( 0, 0 )
    document.body.classList.add( "no-scroll" )
    return (
      <div className="fullscreen">
        <div className="ui pull-right absolute top-1 right-1 z-5"
             style={{ position: "relative" }}>
          <Link to={{ pathname: `/product/${product.map_id}`, search: "" }}><Button className="btn-square"><i className="icon-cancel"/></Button></Link>
        </div>
        
        <div className="tc">
          <div className="zoom-out img-container h-100 flex justify-center">
            {children}
          </div>
        </div>
        
        <div className="ui ui-bottom pull-right ">
          <div className="product-images">
            <ProductThumbnails product={product} fullscreen={true} query={query}/>
          </div>
        </div>
      </div>
    )
  }
}

const TitleSection = ( { product, hasRabatt } ) => {
  
  const hasBulletPoints = product.desc.des && product.desc.des.indexOf( ">" ) > -1
  let bullets = []
  if ( hasBulletPoints ) {
    bullets = product.desc.des.split( ">" ).filter( e => e ).map( e => e.trim() )
  }
  
  const brand = shop.config.brandById[ product.extras.brand ]
  const to = `/collection/${product.cats && product.cats[ 0 ].cat_id}`
  return (
    <section className="product-title mb0 pb0">
      <div className="brand mb3">
        {product.extras.brand ? <div>
          {/*<img src={`/assets/brands/${product.extras.brand}.png`} className="mr3"/>*/}
          <Link to={to}>
            {brand && <div><img height={"80px"} src={brand.logo} alt={brand.title}/></div>}
            {!brand && <span>{product.extras.brand}</span>}
          </Link>
        </div> : null
        }</div>
      <div className="title">{product.title}</div>
      {hasBulletPoints && <div className={"bullet-points pt3"}>
        <ul>
          {bullets.map( point => {
            return <li>{point}</li>
          } )}
        </ul>
      </div>}
      
      {/* Price*/}
      {shop.session && <div className="price pt3">
        <div className="cf">
          
          <div className="fl">
            {hasRabatt && <div><Price className="fw2 f5 strike">{Number( product.pinfos.brutto )}</Price></div>}
            <strong><Price>{product.price}</Price></strong> <br/>
          </div>
          
          {hasRabatt && <div className="cf">
            <div className="badge red">{product.pinfos.zuab}%</div>
          </div>}
        </div>
      
      </div>}
      <div className="cf id pb2"> {translate( "product.articlenr" )}: {product.article_nr}</div>
      {/* Availability*/}
      {shop.session && <Availability product={product}/>}
    </section>
  )
}

TitleSection.propTypes = {
  product: PropTypes.object
}

const Availability = ( { product } ) => {
  let notice = product.getNotice()
  return (
    <div className="availability">
      {notice}
    </div>
  )
}

const ActionSection = ( { product, onChange, onAdd } ) => {
  const list = shop.orderlist.default
  return (
    <section className="product-actions pt2 mb2">
      <div style={{ display: "inline-block " }}>
        <ProductQuantityGroup product={product}
                              list={list}
                              onChange={onChange}
                              onAdd={onAdd}
                              large/>
        <div className="button-group button-group--secondary">
          <ButtonLove list={list}
                      elementInActive={<Button><i className="icon icon-heart-empty"/> {translate( "orderlist.on_orderlist" )}</Button>}
                      elementActive={<Button><i className="icon icon-heart"/> {translate( "orderlist.on_orderlist" )}</Button>}
                      product={product}/>
          {/*<Link className="text-secondary"*/}
          {/*to={`/brand/${product.extras.herst}`}>
           <Button>...mehr {product.extras.herst}*/}
          {/*</Button>*/}
          {/*</Link>*/}
        </div>
      </div>
    </section>
  )
}

ActionSection.propTypes = {
  product : PropTypes.object,
  onChange: PropTypes.func,
  onAdd   : PropTypes.func,
}

const DescriptionSection = ( { product } ) => (
  <section className="description">
    {product.desc.des ? product.desc.des : product.desc.short_des}
  </section>
)

DescriptionSection.propTypes = {
  product: PropTypes.object,
}



// WEBPACK FOOTER //
// ./src/pages/ProductPage.js